// «Push» della sessione: il suo branch sul git del progetto, quando il progetto lo vuole a mano
// (o per rifarlo dopo un push non riuscito). Solo per le sessioni di un progetto con git.
import { useEffect, useState } from 'react';
import { ApiError, api } from '../../lib/api';
import type { Project } from '../../lib/api';
import { Button } from '../../components/Button';
import { useStore } from '../../store/StoreProvider';

export function PushButton({ sessionId, projectId }: { sessionId: string; projectId?: string }) {
  const { toast } = useStore();
  const [project, setProject] = useState<Project | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!projectId) return;
    api.projects().then(
      (r) => setProject(r.projects.find((p) => p.id === projectId) ?? null),
      () => setProject(null),
    );
  }, [projectId]);

  if (!project?.git) return null;
  return (
    <Button
      size="sm"
      icon="git-fork"
      loading={busy}
      title={`Push su ${project.git.repo}`}
      onClick={() => {
        setBusy(true);
        api.pushSession(sessionId).then(
          (r) => {
            toast({ kind: 'success', title: 'Push fatto', body: r.detail });
            setBusy(false);
          },
          (e: unknown) => {
            toast({
              kind: 'danger',
              title: 'Push non riuscito',
              body: e instanceof ApiError && e.detail ? e.detail : 'Riprova.',
            });
            setBusy(false);
          },
        );
      }}
    >
      Push
    </Button>
  );
}
